import React from 'react';
import { Drawer, useMediaQuery, useTheme, Box, styled } from '@mui/material';
import { useLayoutContext } from 'contexts/LayoutContext';
import SidebarContent from './SidebarContent';

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: theme.sidebar.width,
  flexShrink: 0,
  flexBasis: theme.sidebar.width,
  height: '100vh',
  padding: theme.spacing(
    theme.spacingSizes.md,
    0,
    theme.spacingSizes.md,
    theme.spacingSizes.sm,
  ),
  backgroundColor: theme.palette.background.default,
}));

const Sidebar: React.FC = () => {
  const theme = useTheme();
  const { isSidebarOpen, setSidebarOpen } = useLayoutContext();

  const hasDrawer = useMediaQuery(
    theme.breakpoints.down(theme.sidebar.drawerBreakpoint),
  );

  if (hasDrawer) {
    return (
      <Drawer
        variant="temporary"
        open={isSidebarOpen}
        onClose={() => {
          setSidebarOpen(false);
        }}
      >
        <Wrapper>
          <SidebarContent />
        </Wrapper>
      </Drawer>
    );
  } else {
    return (
      <Wrapper>
        <SidebarContent />
      </Wrapper>
    );
  }
};

export default Sidebar;
